import React, { Component, Fragment } from 'react';

import { Grid } from 'components/grid';
import { I18n } from 'components/translate';
import { inject, observer, PropTypes } from 'mobx-react';

import DragDropComponent from './sortable/DragDropComponent';

@inject('QuizStore')
@observer
export default class QuizProfile extends Component {
  static propTypes = {
    QuizStore: PropTypes.objectOrObservableObject
  };

  change = (e) => {
    this.setState({ name: e.target.value });
  };
  render() {
    const { profiles } = this.props.QuizStore;

    return (
      <Fragment>
        <Grid block>
          <h2 className="mb__md">
            <I18n label="general.profiles" />
          </h2>
          <p className="mb__md">
            <I18n label="quiz_editor.profiles.description" />
          </p>

          <div>
            <DragDropComponent
              type="profiles"
              items={profiles}
              droppableId="profiles-droppable"
            />
          </div>
        </Grid>
      </Fragment>
    );
  }
}
